import { CastToNumber, CreditLineResultStatus, EnumSchema, PolicyType } from '@40seas/entities/common';
import { z } from 'zod';
import { CreditLineBreakdown, CreditLineBreakdownSchema } from './credit-line.breakdown';

export class CreditLineResult {
    status: CreditLineResultStatus;
    creditLimit?: number;
    decisionNote?: string;
    breakdown?: CreditLineBreakdown;
    decisionType?: PolicyType;
}

export const EditableCreditLineResultSchema = z.union([
    z
        .object({
            status: z.enum([
                CreditLineResultStatus.Approved,
                CreditLineResultStatus.Preapproved,
                CreditLineResultStatus.OnHold,
                CreditLineResultStatus.Canceled,
            ]),
            creditLimit: CastToNumber(z.number().gt(0, 'Credit limit must be greater than $0')).optional(),
            breakdown: CreditLineBreakdownSchema.optional(),
            decisionType: EnumSchema(PolicyType).optional(),
            decisionNote: z.string().nullish(),
        })
        .strict(),
    z
        .object({
            status: EnumSchema(CreditLineResultStatus, [CreditLineResultStatus.Approved, CreditLineResultStatus.Preapproved]),
            decisionType: EnumSchema(PolicyType).optional(),
            breakdown: CreditLineBreakdownSchema.optional(),
            decisionNote: z.string().nullish(),
        })
        .strict(),
]);

export const CreditLineResultSchema = z
    .object({
        status: EnumSchema(CreditLineResultStatus),
        creditLimit: z.number().gt(0, 'Credit limit must be greater than $0').optional(),
        breakdown: CreditLineBreakdownSchema.optional(),
        decisionType: EnumSchema(PolicyType).optional(),
        decisionNote: z.string().nullish(),
    })
    .strict();
